import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import rootReducer from '../reducers/RootReducer'

import createSagaMiddleware from 'redux-saga'
import logger from 'redux-logger'
import rootSaga from 'core/sagas/RootSaga'

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware()

const middlewares = [sagaMiddleware, logger]

const store = configureStore({ reducer: rootReducer, middleware: middlewares, devTools: true })

// Run the saga
sagaMiddleware.run(rootSaga)

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store
